import React, { useEffect, useRef } from "react";
import { Chip } from "@mui/material";

import ringWav from "../../Raw/fbk.mp3";

const UserFBK = ({ status, userName }) => {
  const previousStatus = useRef();
  const audioRing = useRef(new Audio(ringWav));

  const speakFeedback = (status) => {
    const name = userName || "Unknown user";
    let message;

    switch (status) {
      case "I am in danger":
        message = `${name} is in danger`;
        break;
      case "We are not stopping here":
        message = `${name} said they are not stopping here`;
        break;
      case "Yes, we have arrived":
        message = `${name} has arrived at the destination`;
        break;
      case "I am being delayed":
        message = `${name} is being delayed`;
        break;
      case "No Feedback":
      case "":
        message = `${name} has not given any feedback yet`;
        break;
      case "Something else":
        message = `${name} gave a different response`;
        break;
      default:
        message = `${name} says: ${status}`;
    }

    const synth = typeof window !== "undefined" ? window.speechSynthesis : null;
    if (!synth || synth.speaking) return;

    const utterance = new SpeechSynthesisUtterance(message);
    utterance.lang = "en-US";
    utterance.rate = 1;
    utterance.pitch = 1;
    utterance.volume = 1;

    synth.speak(utterance);
  };

  useEffect(() => {
    if (previousStatus.current !== undefined && previousStatus.current !== status) {
      audioRing.current.play().catch((e) => {
        // console.warn("Audio playback failed:", e);
      });

      if (status !== undefined && status !== null) {
        speakFeedback(status);
      }
    }

    previousStatus.current = status;
  }, [status, userName]);

  const getColor = () => {
    if (
      status === "We are not stopping here" ||
      status === "I am in danger" ||
      status === "No Movement Yet"
    ) {
      return { color: "#d50000" };
    } else if (
      status === "Yes, we have arrived" ||
      status === "I am being delayed" ||
      status === "Delay - I am Safe"
    ) {
      return { color: "#1b5e20" };
    } else if (status === "No Feedback" || status === "Still at Start Point") {
      return { color: "#ff6d00" };
    } else if (status === "Traffic Issue") {
      return {
        color: "#d2db28ff",
      };
    } else if (status === "Something else") {
      return {
        color: "black",
      };
    }
  };

  const color = getColor();

  return (
    <Chip
      label={
        <div style={{ textAlign: "center" }}>
          <span>{status === "" ? "No Feedback" : status}</span>
        </div>
      }
      style={{
        backgroundColor: color?.color,
        color: "white",
        borderRadius: "5px",
        fontWeight: "bold",
        height: "auto",
        padding: "5px",
      }}
    />
  );
};

export default React.memo(UserFBK);
